// The texts come from the dictionary at call time: they were Turkish in the code, so English
// visitors saw "Başarılı", "Hata" and "Tamam", and the success dialog had no button text at all
// (Buefy's own "OK").
const text = (Vue, section, key, fallback) => {
	const lang = Vue.prototype.$lang;
	return (lang && lang[section] && lang[section][key]) || fallback;
};

export const Modals = {
	install(Vue) {
		Vue.prototype.$successModal = (msg) => {
			return {
				title: text(Vue, 'Menus', 'SuccessTitle', 'Başarılı'),
				message: msg,
				confirmText: text(Vue, 'Menus', 'Okay', 'Tamam'),
				type: 'is-success',
				hasIcon: true,
				icon: 'check-circle',
				ariaRole: 'alertdialog',
				ariaModal: true
			};
		};
		Vue.prototype.$errorModal = (res) => {
			return {
				title: text(Vue, 'Member', 'ErrorTitle', 'Hata'),
				// A validation failure (400 from model binding) carries no error_description;
				// the dialog used to open with no message at all.
				message: res.errorDecription || text(Vue, 'Menus', 'ErrorGeneric', ''),
				confirmText: text(Vue, 'Menus', 'Okay', 'Tamam'),
				type: 'is-danger',
				hasIcon: true
			};
		};
	}
};
